<template>
  <div>
    <a-form :model="searchForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="发布平台">
            <a-select
              v-model="searchForm.line_id"
              allowClear
              show-search
              option-filter-prop="children"
              placeholder="请选择发布平台"
              style="width: 100%"
            >
              <a-select-option v-for="item in platformList" :key="item.id" :value="item.id">
                {{ item.org }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="关键词">
            <a-input v-model="searchForm.keyword" allowClear placeholder="请输入关键词" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="是否生效">
            <a-select v-model="searchForm.status" allowClear placeholder="请选择" style="width: 100%">
              <a-select-option :value="1">是</a-select-option>
              <a-select-option :value="2">否</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="创建人员">
            <a-input v-model="searchForm.creator" allowClear placeholder="请输入姓名/工号" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="更新人员">
            <a-input v-model="searchForm.updator" allowClear placeholder="请输入姓名/工号" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="创建时间">
            <v-range-picker v-model="createTimes" @change="onCreateAtChange" :placeholder="['开始时间', '结束时间']" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="更新时间">
            <v-range-picker v-model="updateTimes" @change="onUpdateAtChange" :placeholder="['开始时间', '结束时间']" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="序号">
            <a-input v-model="searchForm.id" allowClear placeholder="请输入" style="width: 100%" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <!-- 搜索按钮 -->
    <div class="flex-sb">
      <div>
        <a-button type="primary" icon="plus-circle" @click="handleAddKeyword">新增</a-button>
        <a-button type="primary" style="margin-left: 5px" @click="handleToThesaurus">词库管理</a-button>
      </div>
      <div>
        <a-button type="primary" icon="search" style="margin-right: 10px" @click="search">查询</a-button>
        <a-button type="primary" icon="delete" ghost @click="handleClear">清空</a-button>
      </div>
    </div>

    <!-- 表格 -->
    <a-table
      row-key="id"
      :columns="columns"
      :loading="loading"
      :data-source="data"
      :row-selection="{ ids, onChange: onSelectChange }"
      style="margin-top: 20px"
      @change="handleTableChange"
      :pagination="pagination"
    >
      <template slot="project" slot-scope="text, record">
        <span>{{ getOrg(record) }}</span>
      </template>
      <template slot="createdUser" slot-scope="text, record">
        {{ record.createdUser.name }}({{ record.createdUser.number }})
      </template>
      <template slot="url" slot-scope="text">
        <a v-if="text" :href="text" target="_blank">{{ text }}</a>
        <span v-else>--</span>
      </template>
      <template slot="creator" slot-scope="text, record">
        <div>
          <span>创建：</span>
          <template v-if="record.creator_name">
            <span>{{ record.creator_name }}</span>
            <span>({{ record.creator_number }})</span>
          </template>
          <template v-else>--</template>
        </div>
        <div>
          <span>更新：</span>
          <template v-if="record.updator_name">
            <span>{{ record.updator_name }}</span>
            <span>({{ record.updator_number }})</span>
          </template>
          <template v-else>--</template>
        </div>
      </template>
      <template slot="created_at" slot-scope="text, record">
        <div>
          <span>创建：</span>
          <span>{{ record.created_at | dayjs }}</span>
        </div>
        <div>
          <span>更新：</span>
          <span>{{ record.updated_at | dayjs }}</span>
        </div>
      </template>
      <template slot="status" slot-scope="text, record">
        <span>{{ Number(record.status) === 1 ? '是' : '否' }}</span>
      </template>
      <template slot="operator" slot-scope="text, record">
        <a-button size="small" type="link" @click="handleTableCommand('edit', record)">编辑</a-button>
        <a-button
          v-if="Number(record.status) === 2"
          size="small"
          type="link"
          @click="handleTableCommand('delete', record)"
        >
          <span style="color: red">删除</span>
        </a-button>
      </template>
    </a-table>

    <!-- 添加/编辑关键词 -->
    <a-modal width="40%" v-model="visible" :title="isEdit ? '编辑关键词' : '添加关键词'" :afterClose="handleCancel">
      <a-form-model ref="formDom" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="发布平台" prop="line_id">
          <a-select
            v-model="form.line_id"
            allowClear
            show-search
            option-filter-prop="children"
            placeholder="请输入或选择"
            @change="orgChange"
          >
            <a-select-option v-for="item in platformList" :key="item.id" :value="item.id">{{
              item.org
            }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="关键词" placeholder="请选择关键词，可多选" prop="keyword">
          <a-select v-model="form.keyword" allowClear mode="multiple" style="width: 100%">
            <a-select-option v-for="(item, index) in keywordList" :key="index" :value="item">{{ item }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="关联显示网址" prop="url">
          <a-input v-model.trim="form.url" allowClear :maxLength="200" placeholder="请输入关联显示网址" />
        </a-form-model-item>
        <a-form-model-item label="是否生效" prop="status">
          <a-radio-group v-model="form.status">
            <a-radio :value="1">是</a-radio>
            <a-radio :value="2">否</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button key="back" @click="handleCancel"> 取 消 </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit"> 提 交 </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { ref, reactive, onMounted, toRefs, getCurrentInstance } from '@vue/composition-api'
import pagination from '@/composables/pagination'
import { searchForm, columns, form, rules } from './business/index'
import { strategyCommand } from './business/tableList'
import api from '@/api/'
import moment from 'moment'
import { cloneDeep } from 'lodash'

export default {
  components: {},
  name: 'KeywordIndex',
  setup(props, { root }) {
    // 获取当前实例
    const _this = getCurrentInstance()
    // 分页信息
    const pagData = pagination()
    const { handleTableChange } = pagData
    const state = reactive({
      ...pagData,
      columns,
      createTimes: [],
      updateTimes: [],
      platformList: [],
      ids: [],
      rules,
      form: cloneDeep(form),
      searchForm: cloneDeep(searchForm),
      options: [], // 平台树数据
      line_ids: [], // 发布平台
      keywordList: []
    })

    onMounted(async () => {
      await methods.getPlatform()
      methods.getList()
    })

    const methods = {
      onCreateAtChange(date, dateString) {
        if (dateString[0] === '') {
          _this.searchForm.created_at = []
          return
        }
        _this.searchForm.created_at = [
          moment(dateString[0]).startOf('day').format('X'),
          moment(dateString[1]).endOf('day').format('X'),
        ]
      },
      onUpdateAtChange(date, dateString) {
        if (dateString[0] === '') {
          _this.searchForm.updated_at = []
          return
        }
        _this.searchForm.updated_at = [
          moment(dateString[0]).startOf('day').format('X'),
          moment(dateString[1]).endOf('day').format('X'),
        ]
      },
      // 获取平台列表
      async getPlatform() {
        const res = await api.LineListNew()
        if (res.code === '000000' && res.data && Array.isArray(res.data)) {
          state.platformList = res.data
          const data = res.data.map((item) => {
            const params = {
              id: parseInt(item.id),
              parent_id: item.parent_id,
              label: item.name,
              value: parseInt(item.id),
              org: item.org,
              project: item.project,
              staff_style: item.staff_style,
              type: item.type,
            }
            return params
          })
          state.options = _this.buildTree(data, 0)
        }
      },
      buildTree(arr, parentId) {
        const children = arr.filter((node) => node.parent_id === parentId)
        if (!children.length) {
          return []
        }
        return children.map((node) => ({
          ...node,
          children: _this.buildTree(arr, node.id),
        }))
      },
      // 列表
      async getList() {
        _this.loading = true
        const res = await api.recommendKeywordList({
          ..._this.searchForm,
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize,
        })
        const { list, pagination } = res.data
        _this.data = list
        _this.pagination.total = Number(pagination.total)
        _this.loading = false
      },

      // 添加关键词
      handleAddKeyword() {
        _this.visible = true
        _this.isEdit = false
      },

      // 跳转词库管理
      handleToThesaurus() {
        _this.$router.push({ path: '/websiteAdmin/thesaurus' })
      },

      // 表格变化事件
      handleTableCommand(type, ...arg) {
        strategyCommand[type].call(_this, ...arg)
      },

      // 查询
      search() {
        _this.pagination.current = 1
        _this.getList()
      },
      // 清空
      handleClear() {
        state.searchForm = cloneDeep(searchForm)
        state.line_ids = []
        state.createTimes = []
        state.updateTimes = []
        _this.search()
      },
      orgChange(val, selectedOptions) {
        if (val) {
          const select_item = _this.platformList.find((item) => item.id.toString() === val.toString())
          const { project, staff_style, type } = select_item
          state.form.project = project
          state.form.staff_style = staff_style
          state.form.type = type
        } else {
          state.form.line_id = undefined
          state.form.project = undefined
          state.form.staff_style = undefined
          state.form.type = undefined
        }
        _this.getKeywordList()
      },
      getOrg(record) {
        const obj = _this.platformList.find(
          (item) =>
            Number(item.project) === Number(record.project) &&
            Number(item.staff_style) === Number(record.staff_style) &&
            Number(item.type) === Number(record.type)
        )
        return obj ? obj.org : ''
      },
      onSelectChange(ids) {
        _this.ids = ids
      },
      // 添加/编辑
      handleSubmit() {
        _this.loading = true
        _this.$refs.formDom.validate(async (valid) => {
          let res = null
          const params = { ..._this.form }
          if (valid) {
            _this.loading = false
            if (_this.isEdit) {
              res = await api.upDateRecommendKeyWord(params)
            } else {
              res = await api.createRecommendKeyWord(params)
            }
            if (_this.$validate(res)) {
              _this.$message.success(_this.isEdit ? '编辑成功~' : '添加成功~')
              _this.visible = false
              _this.getList()
              _this.$refs.formDom.resetFields()
            }
            _this.$nextTick(() => {
              _this.loading = false
            })
          } else {
            _this.$message.warning('请检查信息是否填写完成')
            _this.loading = false
          }
        })
      },
      // 取消/关闭
      handleCancel() {
        _this.form = {
          line_id: undefined, // 发布平台
          project: undefined,
          staff_style: undefined,
          type: undefined,
          keyword: [], // 关键词
          url: undefined,
          status: 1,
        }
        this.keywordList = []
        _this.$refs.formDom.resetFields()
        _this.visible = false
      },
      // 列表
      async getKeywordList() {
        const { line_id, project, staff_style, type } = state.form
        const res = await api.keywordList({
          line_id,
          project,
          staff_style,
          type,
          page: 1,
          per_page: 50,
        })
        const { list } = res.data
        const data_list = list.map(item => {
          const listItem = item.keyword.split(',')
          return listItem
        })
        _this.keywordList = [...new Set(data_list.flat(1))]
      },
    }

    return {
      ...toRefs(state),
      ...methods,
      ...pagination(),
    }
  },
}
</script>
